import { SearchDropdownState } from '@/state';
import {
    ActionType,
    AddSearchQueryAction,
    GetState,
    SetDropdownAction,
    SetFilterPanelAction,
    SetSearchPanelAction,
    SetSearchTimestampAction,
} from './actiontypes';
import {
    clearPlaceNames,
    fetchPlaceNames,
    loopupCoordinateForRoadref,
} from '@/middleware/fetchMisc';
import { Vegsystemreferanse } from '@/domain/omrader';
import { Dispatch } from '@/state/store';
import { DropdownItemData } from '@/components/avgrensning/search/dropdown/DropdownItem';

// RETHINK: Check if the actions in this section are necessary.

export type addSearchQueryT = (
    searchQuery: DropdownItemData
) => (dispatch: Dispatch) => void;
export const addSearchQuery: addSearchQueryT =
    (searchQuery: DropdownItemData) => dispatch => {
        const searchQueryAction: AddSearchQueryAction = {
            type: ActionType.ADD_SEARCH_QUERY,
            searchQuery: searchQuery,
        };
        dispatch(searchQueryAction);
    };

export type searchFieldUpdatedT = (
    searchString: string
) => (dispatch: Dispatch, getState: GetState) => void;
export const searchFieldUpdated: searchFieldUpdatedT =
    (searchString: string) => (dispatch, getState) => {
        const term = searchString.trim().replace(/[;?"']/g, '');
        const onlyNumbers = term.match(/^[\d.-@]+$/);
        if (!onlyNumbers) {
            if (term.length > 1 || term === 'å') dispatch(fetchPlaceNames(term));
            else if ((getState().searchState.placeNames?.hits ?? 0) > 0)
                dispatch(clearPlaceNames());
        }
    };

export type loadMorePlaceNamesT = (
    searchString: string,
    page: number
) => (dispatch: Dispatch, getState: GetState) => void;
export const loadMorePlaceNames: loadMorePlaceNamesT =
    (searchString: string, page: number) => (dispatch, _) => {
        const term = searchString.trim().replace(/[;?"']/g, '');
        dispatch(fetchPlaceNames(term, page));
    };

export type setSearchTimestampT = (date: Date | null) => (dispatch: Dispatch) => void;
export const setSearchTimestamp: setSearchTimestampT = date => dispatch => {
    const setDropdownAction: SetSearchTimestampAction = {
        type: ActionType.SEARCH_TIMESTAMP_SET,
        date,
    };
    dispatch(setDropdownAction);
};
export type setDropdownStateT = (
    searchDropdownState: SearchDropdownState
) => (dispatch: Dispatch) => void;
export const setDropdownState: setDropdownStateT =
    (searchDropdownState: SearchDropdownState) => dispatch => {
        const setDropdownAction: SetDropdownAction = {
            type: ActionType.SEARCH_DROPDOWN_SET,
            searchDropdownState,
        };
        dispatch(setDropdownAction);
    };

export type highlightRoadsystemReferenceT = (
    vegsystemreferanse: Vegsystemreferanse
) => (dispatch: Dispatch) => void;
export const highlightRoadsystemReference: highlightRoadsystemReferenceT =
    (vegsystemreferanse: Vegsystemreferanse) => dispatch => {
        dispatch(loopupCoordinateForRoadref(vegsystemreferanse));
    };

/* Mobile navigation */

// RETHINK: Can these manage "open" in local state instead?
export type setFilterPanelOpenT = (open: boolean) => (dispatch: Dispatch) => void;
export const setFilterPanelOpen: setFilterPanelOpenT = (open: boolean) => dispatch => {
    const filterPanelAction: SetFilterPanelAction = {
        type: ActionType.MOBILE_FILTER_OPEN_SET,
        filterPanelOpen: open,
    };
    dispatch(filterPanelAction);
};
export type setSearchPanelOpenT = (open: boolean) => (dispatch: Dispatch) => void;
export const setSearchPanelOpen: setSearchPanelOpenT = (open: boolean) => dispatch => {
    const searchPanelAction: SetSearchPanelAction = {
        type: ActionType.MOBILE_SEARCH_OPEN_SET,
        searchPanelOpen: open,
    };
    dispatch(searchPanelAction);
};
